import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {AutoplayCheckNextSpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayCheckNextSpinUIAct';
import {AutoplayIdleUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayIdleUIAct';
import {AutoplayEnableSpinAutoModeUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayEnableSpinAutoModeUIAct';

export class AutoplayIdleUIState extends UIState {
    public static readonly ID = 'AutoplayIdleUIState';

    public setAct(): void {
        this.act = sequence([
            AutoplayEnableSpinAutoModeUIAct,
            AutoplayCheckNextSpinUIAct,
            AutoplayIdleUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isAutoplay.value;
    }
}